import React from "react";
import "./Resources.css";
import design from './design.jpg'

const Resources = () => {
  return (
    <div>
      <section className="resources-page">
        <h2 className="resources-title-page">Resources Available with us</h2>

        <div className="circle-center-page">
          {/* Top Left - Office Staff */}
          <div className="quarter top-left-q-page">
            {/* <img src={officeIcon} alt="Office Staff" className="circle-icon" /> */}
            <h3 className="circle-heading-page">Office Staff</h3>
            <p className="circle-text-page">
              Project Managers, Hydraulic Designers, Planning and Design
              engineers, Accountant, Purchase officers, legal executive, AutoCAD
              draftsmen, AutoCAD Draftsman's, Accountant, PRO
            </p>
          </div>

          {/* Top Right - Site Staff */}
          <div className="quarter top-right-q-page">
            {/* <img src={siteIcon} alt="Site Staff" className="circle-icon" />0 */}
            <h3 className="circle-heading-page">Site Staff</h3>
            <p className="circle-text-page">
              Experienced Technical Personnels, Civil Engineers (BE/DCE),
              Surveyors (ITI/DCE), Graduation Degree holders Supervisors & site
              engineers.
            </p>
          </div>

          {/* Bottom Left - Software */}
          <div className="quarter bottom-left-q-page">
            {/* <img src={softwareIcon} alt="Software" className="circle-icon" /> */}
            <h3 className="circle-heading-page">Software</h3>
            <p className="circle-text-page">
              Auto-Cad, E-Survey, KY Pipe, HEC-RAS, water gems, stadpro,
              primavera, msp, ms office etc.
            </p>
          </div>

          {/* Bottom Right - Equipment */}
          <div className="quarter bottom-right-q-page">
            {/* <img src={equipmentIcon} alt="Equipment" className="circle-icon" /> */}
            <h3 className="circle-heading-page">Equipment/Machinery</h3>
            <p className="circle-text-page">
              DGPS, Total Stations, Drones, All types of construction
              equipment’s, Jointing machines, Generators, drilling grouting
              equipment’s, QC equipment's, Utility Vehicles, cameras, projectors
              etc.
            </p>
          </div>
        </div>
      </section>
      
<div className="irs-container">
      {/* Hero Section */}
      <div className="irs-hero">
        <div className="irs-hero-text">
          <h1>Design & DPR – Lift Irrigation & Water Infrastructure</h1>
          <p>
            Detailed surveys, technical design, DPR, estimation, vetting and
            tendering support — end-to-end delivery for irrigation projects.
          </p>
          {/* <a href="#services" className="irs-btn">
            Explore Services
          </a> */}
        </div>
        <div className="irs-hero-image">
          <img src={design} alt="Irrigation Project" />
        </div>
      </div>

      {/* Services Section */}
      <div id="services" className="irs-services">
        <div className="irs-card">
          <h2>Lift Irrigation Scheme</h2>
          <p>
            Survey, Planning & Design, vetting from CDO/VNIT, Estimation,
            Drawings, DPR and Tendering activities.
          </p>
        </div>

        <div className="irs-card">
          <h2>Pipe Network (PDN)</h2>
          <p>
            Survey, Design & Vetting of pipe networks, estimation, drawings,
            DPR, SLTAC proposals and tendering work.
          </p>
        </div>

        <div className="irs-card">
          <h2>Barrages</h2>
          <p>
            Survey, hydraulic studies, dam-line finalization, flood
            estimation, vetting, DPR, MWRRA/AA proposals, PMC and tender
            assistance.
          </p>
        </div>

        <div className="irs-card">
          <h2>Dams & Canals</h2>
          <p>
            Design & Vetting of hydraulic structures like canals & dams.
            Estimation, DPR, AA & Revised AA proposals.
          </p>
        </div>

        <div className="irs-card">
          <h2>EAP & Flood Forecast</h2>
          <p>
            Emergency Action Plans, Red/Blue line mapping, ROS & GOS for dams,
            barrages and river studies.
          </p>
        </div>

        <div className="irs-card">
          <h2>Other Services</h2>
          <p>
            Architectural & Structural design for residential/commercial
            projects. Industrial work: roads, bridges, sheds & steel
            structures.
          </p>
        </div>
      </div>

      {/* Footer */}
      <div className="irs-footer">
        <h3>Ready to discuss your project?</h3>
        <a className="irs-btn-dark" href="/contactus">
          Contact Us
        </a>
      </div>
    </div>
      
    </div>
  );
};

export default Resources;
